var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customUserImportUser_empty"> <div class="row mt-3"> <div class="col-12 col-sm-12 col-md-12 col-xl-12 grid-margin stretch-card"> <div class="card"> <div class="card-body">  <form class="contact-form"> <div class="row" style="margin-left:0px;margin-top:25px"> <div class="col-md-12"> <input id="customUserImportUser_filePond" type="file" class="filepond"> </div> </div> </form> </div> </div> </div> </div> </div>';
}
return __p;
};
